import { getAuthInstance } from '@fusion/auth-v3'

export const getMetadata = function (x: string) {
  const metadata = APP_ENV.VITE_APP_SITE_NAMESPACE + '/user_metadata'
  const auth = getAuthInstance()
  if (auth.user?.[metadata]) {
    return auth.user[metadata][x]
  }
}
